import { createApi } from '@reduxjs/toolkit/query/react';
import axios from 'axios';


const BASE_URL = process.env.REACT_APP_API_URL;


const axiosBaseQuery = ({ baseUrl } = { baseUrl: BASE_URL }) => async ({
  url,
  method,
  data,
  params,
}) => {
  try {
    // console.log(`Inside Axios Base!!!`);
    // console.log(`Token - ${JSON.stringify(localStorage.token)}`);
    // console.log(`API Key - ${JSON.stringify(localStorage.apiKey)}`);
    let result = null;
    if (localStorage.getItem("token") !== "null" && localStorage.rememberMe === "true") {
      result = await axios({
        url: baseUrl + url,
        method,
        data,
        params,
        headers: {
          Authorization: localStorage.token,
          "X-Api-Key": localStorage.apiKey,
          //commentout
          "Refresh": localStorage.refresh // CYL: Disabled due to CORS error
        }
      });
    } else if (localStorage.getItem("token") !== "null" && localStorage.rememberMe === "false"){
      result = await axios({
        url: baseUrl + url,
        method,
        data,
        params,
        headers: {
          Authorization: localStorage.token,
          "X-Api-Key": localStorage.apiKey
        }
      });
    } else if (localStorage.getItem("GoogleToken") !== "null") {
      result = await axios({
        url: baseUrl + url,
        method,
        data,
        params,
        headers: {
          Authorization: localStorage.GoogleToken,
          "X-Api-Key": localStorage.apiKey
        }
      });
    }
    else {
      result = await axios({
        url: baseUrl + url,
        method,
        data,
        params
      });
    }
    return { data: result.data };
  } catch (err) {
    return {
      error: {
        status: err.response?.status,
        data: err.response?.data || err.message,
      },
    };
  }
};

export const VehicleBiddingApi = createApi({
  reducerPath: 'VehicleBiddingApi',
  baseQuery: axiosBaseQuery({ baseUrl: BASE_URL }),
  // cache time
  keepUnusedDataFor: 0,
  tagTypes: ['auctions', 'makes', 'models', 'vehicleauction', 'userAuctionVehicleStatuses'],
  endpoints: () => ({}),
});
